import { reportError } from './reportError';

/**
 * Convert an image file to WebP format using the Canvas API.
 * Returns the original file as fallback if conversion fails or file is already WebP.
 */
export const convertToWebp = async (file: File, quality = 0.85): Promise<File> => {
  if (file.type === 'image/webp') return file;

  try {
    const bitmap = await createImageBitmap(file);
    const canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
    const ctx = canvas.getContext('2d');
    if (!ctx) return file;

    ctx.drawImage(bitmap, 0, 0);
    bitmap.close();

    const blob = await canvas.convertToBlob({ type: 'image/webp', quality });

    const stem = file.name.replace(/\.[^.]+$/, '') || 'image';
    return new File([blob], `${stem}.webp`, { type: 'image/webp' });
  } catch (err) {
    reportError('convertToWebp', err);
    return file;
  }
};
